<template lang="pug">
  v-content
    v-container(fluid)
      v-overlay(:value="!allReady", opacity="0.7")
        v-progress-circular(indeterminate, size="64")
      div(style="display: flex;justify-content: space-between;padding: 1rem;background: white;padding-bottom: .2rem;")
        p(style="font-size: 1.25rem;line-height: 1.5;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;") Edit Payment Voucher
        v-btn(v-if="$route.name !== 'Forex Request' && $route.name !== 'Document Legal F1' && $route.name !== 'Document Legal F2'" color='blue-secondary' to='/my-request-pv') LIST MEMO
    
    v-stepper.pv-stepper(v-model="e1" :disabled="formDisabled")
      v-stepper-header
        v-stepper-step(:complete="e1 > 1" step="1")
          | PV Details
        v-divider
        v-stepper-step(:complete="e1 > 2" step="2")
          | COA Details
        v-divider
        v-stepper-step(step="3") Approval
      v-stepper-items
        v-stepper-content(step="1")
          v-card.mb-2(style="box-shadow: none")
            v-card(flat)
              v-card-text.p-5
                v-row(no-gutters)
                  v-col(cols="3") 
                    v-subheader(color="black")
                      | &nbsp;Business Unit&nbsp;
                      span(style="color: #d42a2a") *
                  v-col(cols="8")
                    v-autocomplete(
                      label="Select Business Unit",
                      id="pvSelectBU"
                      :items="myBuList",
                      :disabled="isNeedReviewStatus",
                      item-text="label",
                      item-value="value",
                      v-model="selectedBU",
                      placeholder="Select",
                      required
                      @change="onBUChange"
                    )
                
                v-row(no-gutters)
                  v-col(cols="3") 
                    v-subheader(color="black")
                      | &nbsp;Payment Request&nbsp;
                      span(style="color: #d42a2a") *
                  v-col(cols="8")
                    v-autocomplete(
                      label="Select Payment Request",
                      id="pvSelectPR"
                      :items="paymentRequests",
                      item-text="label",
                      item-value="value",
                      v-model="selectedPR",
                      placeholder="Select",
                      required
                      :disabled="isNeedReviewStatus"
                      @change="onPRChange"
                      return-object
                      :filter="filterPaymentRequests"
                    )
                      template(v-slot:item="slotProps")
                        v-list-item-title {{ slotProps.item.label }}
                        v-list-item-subtitle {{ slotProps.item.imNo }}
                
                v-row(no-gutters)
                  v-col(cols="3") 
                    v-subheader(color="black")
                      | &nbsp;Subject&nbsp;
                      span(style="color: #d42a2a") *
                  v-col(cols="8")
                    v-text-field(
                      label="Subject",
                      id="pvSubject"
                      v-model="subject"
                      required
                    )

                v-subheader(style="color: #000;font-family: Roboto;font-size: 16px;font-style: normal;font-weight: 600;line-height: normal; margin-top: 1rem;") &nbsp;Pay From&nbsp;
                  span(style="font-style: italic; font-weight: 400;") &nbsp;Bayar Dari

                v-row(no-gutters)
                  v-col(cols="3") 
                    v-subheader(color="black")
                      | &nbsp;Bank Account&nbsp;
                      span(style="color: #d42a2a") *
                  v-col(cols="8")
                    v-autocomplete(
                      label="Select Bank Account",
                      id="pvSelectBankAccount"
                      :items="bankAccounts",
                      item-text="label",
                      item-value="value",
                      v-model="selectedBankAccount",
                      placeholder="Select",
                      required
                      @change="onBankAccountChange"
                      return-object
                    )
                
                v-row(no-gutters v-if="selectedBankAccountData")
                  v-col(cols="3") 
                    v-subheader(color="black") &nbsp;Account Name
                  v-col(cols="8")
                    v-text-field(
                      v-model="accountName"
                      readonly
                    )
                
                v-row(no-gutters v-if="selectedBankAccountData")
                  v-col(cols="3") 
                    v-subheader(color="black") &nbsp;Account Number
                  v-col(cols="8")
                    v-text-field(
                      v-model="accountNumber"
                      readonly
                    )
                
                v-row(no-gutters v-if="selectedBankAccountData")
                  v-col(cols="3") 
                    v-subheader(color="black") &nbsp;Account Type
                  v-col(cols="8")
                    v-text-field(
                      v-model="selectedBankAccountData.account_type"
                      readonly
                    )
                
                v-row(no-gutters v-if="selectedBankAccountData")
                  v-col(cols="3") 
                    v-subheader(color="black") &nbsp;Currency
                  v-col(cols="8")
                    v-text-field(
                      v-model="selectedBankAccountData.currency"
                      readonly
                    )

                v-row(no-gutters)
                  v-col(cols="3") 
                    v-subheader(color="black") &nbsp;Attachment File
                  v-col(cols="8")
                    v-flex(xs12, sm6, md12, mb-2)
                      div.mt-1(style="font-size: 14px") 
                        input#file(
                          v-if="fileName.length > 0",
                          type="file",
                          ref="fileadd",
                          style="display: none",
                          v-on:change="addFile()",
                          accept=".7z, .7zip, .rar, .pdf, .doc, .docx, .zip, .xlsx, .xls, image/*",
                          multiple
                        )
                        v-btn(
                          v-if="fileName.length > 0",
                          outlined,
                          color="primary",
                          @click="$refs.fileadd.click()"
                        ) 
                          v-icon add
                          | Add file
                        input#file(
                          v-if="fileName.length == 0",
                          type="file",
                          ref="file",
                          style="display: none",
                          v-on:change="uploadLampiran()",
                          accept=".7z, .7zip, .rar, .pdf, .doc, .docx, .zip, .xlsx, .xls, image/*",
                          multiple
                        )
                        v-btn(
                          v-if="fileName.length == 0",
                          outlined,
                          color="primary",
                          @click="$refs.file.click()"
                        ) 
                          v-icon add
                          | Add file
                        p.mt-1 Max Size: 5 MB. Allowed: .pdf, .doc, .zip, .7zip, .rar,  .docx, .xlsx, .xls, or images
                        v-alert.mt-2(
                          v-model="uploadAlert",
                          color="red",
                          dense,
                          text,
                          dismissible
                        ) The file is too big. Max file size 5 MB
                        v-row.mt-1
                          v-chip.ma-2(
                            v-if="fileName.length > 0",
                            v-for="(item, index) in fileName",
                            :key="item",
                            close
                            @click:close="removeLampiran(item, index)" 
                          )
                            span(v-if="item.name != null") {{ item.name | truncate(15, '...') }}
                            span(v-else) {{ item | truncate(15, '...') }}
                
          v-btn(depressed, large, id="pvPage1Cancel" style="background-color: #f5f5f5;" text="" @click="$router.push('/my-request-pv')") Cancel
          v-btn(depressed, large, id="pvPage1Next" style="margin: 0.6rem" :disabled="step1Validation || !allReady" color="primary", @click="e1 = 2; loadCOAList()") Next

        v-stepper-content(step="2")
          v-card(style="box-shadow: none")
            h2.mb-1 COA Details
              span.color-red *
            
            div(style="display: flex; width: 100%; padding: 1rem 0 0 0")
              div(style="flex: 0 1 30%; margin-right: 1rem; width: 40px",)
                h4(style="margin-bottom:.4rem") Currency
                v-autocomplete(
                  id="pvCurrencyBoxDisplay"
                  v-model="selectedCurrencyInput"
                  dense
                  :items="currencyBox"
                  label="Currency from Payment Request"
                  outlined="",
                  single-line="",
                  hide-details=""
                  disabled
                )
              
              div(style="flex: 0 1 65%; margin-right: 1rem; width: 40px",)
                h4(style="margin-bottom:.4rem") Payment Request Amount
                v-text-field(
                  v-model="formattedPRTotal",
                  dense,
                  outlined="",
                  single-line="",
                  hide-details=""
                  readonly
                  disabled
                )
            
            div(style="display: flex; width: 96%; padding: 1rem 0")
              div(style="flex: 0 1 36%; margin-right: 1rem; width: 40px",)
                h4(style="margin-bottom:.4rem") COA Name
                  span(style="color: #d42a2a") *
                v-autocomplete(
                  v-model="addCOA",
                  id="pvAddCOAName"
                  :items="filteredCOAs",
                  item-text="label",
                  item-value="value",
                  return-object
                  label="Select COA",
                  dense,
                  outlined="",
                  single-line="",
                  hide-details=""
                  :filter="filterCOA"
                )
                  template(v-slot:item="data")
                    v-list-item-content
                      v-list-item-title {{ data.item.label }} - {{ data.item.accountType }}
              
              div(style="flex: 0 1 35%; margin-right: 1rem; width: 40px",)
                h4(style="margin-bottom:.4rem") Description
                  span(style="color: #d42a2a") *
                v-text-field(
                  v-model="addDescription",
                  id="pvAddDescription"
                  label="Description",
                  dense,
                  outlined="",
                  single-line="",
                  :counter="500",
                  :maxlength="500",
                  :rules="[rules.maxDescription]",
                  hint="Maximum 500 characters"
                )
              
              div(style="flex: 0 1 15%; margin-right: 1rem; width: 40px",)
                h4(style="margin-bottom:.4rem") Type
                v-select(
                  v-model="addType",
                  id="pvAddType"
                  :items="[{text:'Debit',value:'debit'},{text:'Credit',value:'credit'}]",
                  item-text="text",
                  item-value="value",
                  label="Type",
                  dense,
                  outlined="",
                  single-line="",
                  hide-details=""
                )
              
              div(style="flex: 0 1 20%; margin-right: 1rem; width: 40px; ",)
                h4(style="margin-bottom:.4rem") Amount
                money(
                  id="pvAddAmount"
                  :maxlength="selectedCurrency.value =='IDR' ? 19: 18",
                  style="width: 100%; height: 40px; line-height: 40px; border-radius: 5px; padding: 0 0.5rem; border: 1px solid #9e9e9e; display: flex; align-items: center;"
                  v-model="addAmount" 
                  v-bind="currencyConfigs[selectedCurrency.value]"
                )
              
              div(style="display:flex; align-items:center;")
                v-btn.ml-2.white--text(id="pvAddCOABtn" color="primary", @click="addCOADetail")
                  v-icon(dark="") add
                  | Add
            
            v-data-table.elevation-1(
              id="coaTable"
              style="border: 1px solid rgb(222 217 217)" 
              :headers="coaHeaders",
              :items="coaDetails",
              fixed-header="",
              height="100%",
              hide-default-footer,
              :items-per-page="-1",
              :header-props="headerProps"
            )
              template(v-slot:item.coa="{ item }")
                span(style="vertical-align: top; margin-top: 0.5rem; display: inline-block;") {{ item.coa.label }}
              
              template(v-slot:item.description="{ item }")
                span(style="display: inline-block; width: 100%; max-width: 200px; word-wrap: break-word; white-space: normal; text-align: left; vertical-align: top; margin-top: 0.5rem;") {{ item.description }}
              
              template(v-slot:item.currency="{ item }")
                span(style="vertical-align: top; margin-top: 0.5rem; display: inline-block;") {{ selectedCurrency.value }}
              
              template(v-slot:item.debit="{ item }")
                span(style="vertical-align: top; margin-top: 0.5rem; display: inline-block;" v-if="item.type === 'debit'") {{ formatCurrency(item.amount, selectedCurrency.value) }}
                span(style="vertical-align: top; margin-top: 0.5rem; display: inline-block;" v-else) -
              
              template(v-slot:item.credit="{ item }")
                span(style="vertical-align: top; margin-top: 0.5rem; display: inline-block;" v-if="item.type === 'credit'") {{ formatCurrency(item.amount, selectedCurrency.value) }}
                span(style="vertical-align: top; margin-top: 0.5rem; display: inline-block;" v-else) -
              
              template(v-slot:item.actions="{ item }")
                span(style="margin-top: 0.5rem; display: inline-block;")
                  v-icon(color="red", @click="removeCOADetail(item)")
                    | delete
              
              template(slot="body.append")
                tr(v-if="coaDetails.length > 0")
                  th(style="font-size:14px !important" class="title" colspan="3") Total Debit Accumulation
                  th(style="font-size:14px !important" class="title")
                    money(v-bind="getMoneyFormat(selectedCurrency.value)" disabled v-model="totalDebit")
                  th
                  th
                tr(v-if="coaDetails.length > 0")
                  th(style="font-size:14px !important" class="title" colspan="3") Total Credit Accumulation
                  th
                  th(style="font-size:14px !important" class="title")
                    money(v-bind="getMoneyFormat(selectedCurrency.value)" disabled v-model="totalCredit")
                  th
              
              template(v-slot:no-data="")
                div(style="margin :2rem")
                  h2 No items
                  h4 Please input and add COA.
            
            div(style="margin-top: 1rem;")
              div(style="margin-bottom: 1rem;")
                h4(style="margin-bottom:.4rem") Notes
                v-textarea(
                  v-model="notes",
                  id="pvNotes"
                  label="Notes (Optional)",
                  dense,
                  outlined="",
                  rows="3"
                  hide-details=""
                )
              
              v-alert(
                outlined
                color="blue-grey"
                dense
                text
                style="margin-top: 0.5rem;"
              )
                strong Disclaimer:
                |  Exchange rates are provided for reference only and are subject to market fluctuations. The actual amount payable in local currency will depend on the exchange rate applicable on the date of payment.
            
            v-alert(
              v-model="coaValidationAlert"
              color="red"
              dense
              close-icon=""
              dismissible
              style="margin-top: 1rem; color: white;"
            ) {{ coaValidationMessage }}
                
          v-btn(depressed, large, id="pvPage2Cancel" style="background-color: #f5f5f5;" text="" @click="$router.push('/my-request-pv')") Cancel
          v-btn(depressed, large, id="pvPage2Back" style="margin: 0.5rem; background: #607D8B; color:#fff", @click="e1 = 1") Back
          v-btn(depressed, large, id="pvPage2Next" style="margin: 0.5rem" :disabled="step2Validation" color="primary", @click="e1 = 3; getMyBUMember(); loadBUDetails()") Next

        v-stepper-content(step="3" style="padding:0")
          v-alert(
            style="margin:0"
            dismissible,
            color="red",
            dark,
            v-model="alert",
            transition="scale-transition"
          ) {{ alertMessage }}
          v-card(style="box-shadow: none; padding:1rem 1rem 1rem 1rem; border-top: 1px solid #adadad;")
            v-layout(row, wrap)
              v-flex(xs6, sm6 class="approver-form-column")
                v-autocomplete(
                  id="pvInternalApprover"
                  style="padding: 0; margin:.5; margin-top: 1rem;",
                  label="Approver",
                  :items="myBuMember",
                  v-model="approver",
                  placeholder="Select",
                  chips,
                  :item-text="item => `${item.position} - ${item.alias} - ${item.name} - ${item.business_unit.bu_name}`",
                  item-value="data",
                  return-object,
                  multiple,
                  :append-icon="'close'"
                  @click:append="handleClearEvent(1)"
                  :readonly="max_total_approver !== 0 ? approver.length >= max_total_approver : false"
                )
                  template(v-slot:selection="data")
                    v-chip(
                      v-bind="data.attrs"
                      :input-value="data.selected"
                      close
                      @click="data.select"
                      @click:close="removeApp(data.item)"
                    ) {{ data.item.alias }}
                  template(v-slot:item="data")
                    v-list-item-content
                      v-list-item-title.mr-1 {{ data.item.alias }} - {{ data.item.position }} ({{ data.item.business_unit.bu_name }})
                      p(style='margin:0; font-size: 12px; color: gray;') {{ data.item.email }}

                v-autocomplete(
                  :search-input.sync='searchCrossBU'
                  v-model="approver"
                  :items="crosBu"
                  chips
                  color="blue-grey lighten-2"
                  label="Approver Cross BU"
                  id="pvCrossApprover"
                  :item-text="item => `${item.position} - ${item.alias} - ${item.name} - ${item.business_unit.bu_name}`",
                  item-value="data"
                  multiple
                  :loading='isLoadingCrossBU'
                  :append-icon="'close'"
                  @click:append="handleClearEvent(2)"
                  hide-no-data=''
                  hint="Enter at least 3 letters to find out the search results."
                  return-object=true
                  :readonly="max_total_approver !== 0 ? approver.length >= max_total_approver : false"
                  style="margin-top: 0.5rem;"
                )
                  template(v-slot:selection="data")
                    v-chip(
                      v-bind="data.attrs"
                      :input-value="data.selected"
                      close
                      @click="data.select"
                      @click:close="removeApp(data.item)"
                    ) {{data.item.alias}}
                  template(v-slot:item="data")
                    template(v-if="typeof data.item !== 'object'")
                      v-list-tile-content(v-text="data.item")
                    template(v-else)
                      v-list-tile-content
                        v-list-tile-title.mr-1 {{data.item.alias}} - {{data.item.position}} ({{ data.item.business_unit.bu_name }})
                        p(style='margin:0; font-size: 12px; color: gray;') {{ data.item.email }}

                v-flex.autocomplete-result.d-flex.flex-row.align-center.mt-3
                  v-checkbox.mr-2(
                    id="pvCBHideTTL"
                    v-model="disabledHidetitle",
                    label="Hide Title",
                    :disabled="useAlias"
                  )
                  v-checkbox(id="pvCBUseAls" v-model="useAlias" label="Use Alias Name")
                  v-checkbox(id="pvCBShowLogo" style='margin-left:1rem' v-model="useLogo" label="Show Company Logo")
                
                p(style="color: #F08703; font-size: 12px" class="mb-0" v-if="use_setting_max_approver && max_total_approver !== 0") *Each memo may have a maximum of ({{max_total_approver}}) approvers assigned within your Business Unit. Kindly ensure that the approver list does not exceed this limit.

              div(style="padding:0 1rem; flex:1")
                .badge-approval.d-flex.approval-tip-card
                  .mr-3
                    img(src="../assets/icon/ic_tips.svg")
                  .align-self-center
                    i Tips: Drag and drop the approver by holding down the left mouse and dragging them. (Approval sequence follow when user input the approver)

                template
                  .mb-5.mt-5
                    p.title.mb-1 Approver
                    ol.autocomplete-results(v-show="approver")
                      draggable.list-group(
                        :list="approver",
                        :disabled="false",
                        ghost-class="ghost",
                        @start="dragging = true",
                        @end="dragging = false"
                      )
                        li.autocomplete-result.d-flex.approver-list-item(
                          v-for="(requestor, i) in approver",
                          :key="i"
                        )
                          span.approver-number {{ i + 1 }}.
                          v-chip.list-group-item.ma-1(@click:close="removeApp(requestor)",x-large,close,label) 
                            div
                              p(style="margin:0; font-size:14px !important") {{ requestor.alias }}  {{  requestor.position ? "- " + requestor.position + "" : ''  }} {{  requestor.business_unit ? "(" + requestor.business_unit.bu_name + ")" : ''  }}
                              p(style='margin:0; font-size: 12px; color: gray;') {{ requestor.email }}
                              p(v-show="requestor.is_active == false" style="margin:0; color: #FF5252; font-size:12px") Approver is not active
              
            div(style="padding-top: 1rem; margin-top: 1rem; border-top: 1px solid #e0e0e0;")
              v-btn(id="pvPage3Cancel" style="background-color: #f5f5f5;margin-left: 1.5rem" depressed, large, text="" @click="$router.push('/my-request-pv')") Cancel
              v-btn(id="pvPage3Back" style="margin-left: 0.5rem" dark, color="blue-grey", depressed, large, @click="e1 = 2") Back
              v-btn.ml-2(
                id="pvPage3btnDraft"
                color="info",
                depressed,
                large,
                v-if="!isNeedReviewStatus"
                :disabled="approver.length == 0 || isLoading",
                @click="submitPV(1)"
              )
                v-icon insert_drive_file
                | &nbsp; Save as Draft
              v-btn(
                id="pvPage3btnSubmit"
                style="margin: 0.5rem" 
                depressed,
                large,
                color="success",
                :disabled="approver.length == 0 || isLoading",
                @click="submitPV(2)"
              ) 
                v-icon send
                | &nbsp; Submit Request
</template>

<script>
import axios from "axios";
import draggable from "vuedraggable";

export default {
  name: "EditPV",
  components: {
    draggable
  },
  data() {
    return {
      isEditMode: true,
      pvId: null,
      existingPV: null,
      currentImNo: "",
      isInitializing: true,
      tembusan: [],
      useLogo: true,
      useAlias: true,
      disabledHidetitle: false,
      e1: 1,
      fileName: [],
      file: [],
      uploadAlert: false,
      currencyConfigs: {},
      isLoading: false,
      notes: "",
      rules: {
        maxDescription: (v) => !v || v.length <= 500 || "Description must be 500 characters or less",
      },
      myBuList: [],
      selectedBU: null,
      paymentRequests: [],
      selectedPR: null,
      subject: "",
      bankAccounts: [],
      selectedBankAccount: null,
      selectedBankAccountData: null,
      accountName: "",
      accountNumber: "",
      coaList: [],
      filteredCOAs: [],
      coaDetails: [],
      addCOA: null,
      addDescription: "",
      addType: "debit",
      addAmount: 0,
      coaHeaders: [
        { text: "COA", value: "coa", sortable: false, width: "20%", align: "left"},
        { text: "Description", value: "description", sortable: false, width: "25%", align: "left"},
        { text: "Currency", value: "currency", sortable: false, width: "10%", align: "center"},
        { text: "Debit", value: "debit", sortable: false, width: "15%", align: "center"},
        { text: "Credit", value: "credit", sortable: false, width: "15%", align: "center"},
        { text: "Actions", value: "actions", sortable: false, width: "15%", align: "center"},
      ],
      headerProps: {
        class: "custom-header",
      },
      selectedCurrencyInput: "IDR",
      selectedCurrency: { value: "IDR", text: "IDR" },
      totalDebit: 0,
      totalCredit: 0,
      grandTotal: 0,
      prTotal: 0,
      coaValidationAlert: false,
      coaValidationMessage: "",
      approver: [],
      myBuMember: [],
      crosBu: [],
      searchCrossBU: null,
      isLoadingCrossBU: false,
      max_total_approver: 0,
      use_setting_max_approver: true,
      dragging: false,
      bu_id: null,
      configsLoaded: false,
      dataLoaded: false,
      alert: false,
      alertMessage: "",
    };
  },
  computed: {
    currencyBox() {
      return Object.keys(this.currencyConfigs).map(currency => ({
        text: currency,
        value: currency
      }));
    },
    formattedPRTotal() {
      if (!this.prTotal || !this.selectedCurrency.value) return '0';
      return this.formatCurrency(this.prTotal, this.selectedCurrency.value);
    },
    step1Validation() {
      if (this.selectedBU && this.selectedPR && this.subject && this.selectedBankAccount) {
        return false;
      }
      return true;
    },
    step2Validation() {
      if (this.coaDetails.length == 0) return true;
      if (this.totalDebit != this.totalCredit) return true;
      // Validate that both totalDebit and totalCredit equal the PR amount
      if (Math.abs(this.totalDebit - this.prTotal) > 0.01) return true;
      if (Math.abs(this.totalCredit - this.prTotal) > 0.01) return true;
      return false;
    },
    formDisabled() {
      return !this.allReady;
    },
    allReady() {
      return this.configsLoaded && this.dataLoaded;
    },
    isNeedReviewStatus() {
      // Lock fields when status is 3 (Need Review)
      return this.existingPV && parseInt(this.existingPV.imStatus, 10) === 3;
    },
  },
  methods: {
    async initializePage() {
      this.setUseAlias();
      this.pvId = this.$route.params.id || null;
      this.isEditMode = !!this.pvId;
      await this.fetchCurrencyConfigs();
      await this.getMyActiveBU();
      if (this.isEditMode && this.pvId) {
        await this.loadExistingPV();
      }
      this.dataLoaded = true;
    },
    async fetchPVDetail(id) {
      const token = localStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };
      try {
        const response = await axios.get(`${process.env.VUE_APP_API}/pv/${id}`, { headers });
        return response.data;
      } catch (error) {
        const legacy = await axios.get(`${process.env.VUE_APP_API_OLD}/api/pv/${id}`, { headers });
        return legacy.data;
      }
    },
    buildPaymentRequestOption(pr) {
      if (!pr) return null;
      const value = pr._id || pr.id || pr.value;
      if (!value) return null;
      const fallbackCurrencyValue = (pr.currency && pr.currency.value) || pr.currency || this.selectedCurrencyInput;
      const imPaymentData = pr.imPaymentData || {
        paymentTotal: pr.total || 0,
        paymentCurrency: {
          value: fallbackCurrencyValue,
        },
      };
      const resolvedOrg = pr.imOrganization || (this.existingPV && this.existingPV.imOrganization) || {};
      return {
        value,
        label: pr.imPerihal || pr.label || pr.imNo || "Payment Request",
        imNo: pr.imNo,
        imPerihal: pr.imPerihal || pr.label,
        data: {
          ...pr,
          _id: value,
          imPaymentData,
          imOrganization: resolvedOrg,
        },
      };
    },
    setExistingPaymentRequest(paymentRequest) {
      const option = this.buildPaymentRequestOption(paymentRequest);
      if (!option) {
        this.selectedPR = null;
        this.prTotal = 0;
        return;
      }
      if (!this.paymentRequests.find(pr => pr.value === option.value)) {
        this.paymentRequests.unshift(option);
      }
      this.selectedPR = option;
      const paymentData = option.data.imPaymentData || {};
      const paymentCurrency = paymentData.paymentCurrency || {};
      this.prTotal = paymentData.paymentTotal || 0;
      const currencyValue = paymentCurrency.value || "IDR";
      this.selectedCurrencyInput = currencyValue;
      this.selectedCurrency = { value: currencyValue, text: currencyValue };
      this.calculateTotal();
    },
    setExistingBankAccount(bankAccount) {
      if (!bankAccount) {
        this.selectedBankAccount = null;
        this.selectedBankAccountData = null;
        this.accountName = "";
        this.accountNumber = "";
        return;
      }
      const value = bankAccount._id || bankAccount.id;
      const option =
        this.bankAccounts.find(acc => acc.value === value) ||
        {
          value,
          label: `${(bankAccount.bank && bankAccount.bank.name) || bankAccount.bank_name || "-"} - ${bankAccount.account_name || "-"} - ${bankAccount.account_no || "-"}`,
          data: bankAccount,
        };
      if (!this.bankAccounts.find(acc => acc.value === option.value)) {
        this.bankAccounts.push(option);
      }
      this.selectedBankAccount = option;
      this.selectedBankAccountData = option.data;
      this.accountName = option.data.account_name || "";
      this.accountNumber = option.data.account_no || "";
    },
    mapExistingCOADetail(detail) {
      if (!detail) return null;
      const coaId = detail.coa_id || detail.coaId || (detail.coa && (detail.coa.value || detail.coa._id)) || detail.id;
      const matched = this.coaList.find(item => item.value === coaId);
      const base = matched || {
        value: coaId,
        label: `${detail.coa_code || ""} - ${detail.coa_name || detail.description || ""}`,
        kode: detail.coa_code || "",
        data: { description: detail.coa_name || detail.description || "" },
      };
      return {
        coa: base,
        description: detail.description || "",
        type: detail.type || "debit",
        amount: parseFloat(detail.amount) || 0,
      };
    },
    setExistingCOADetails(details) {
      if (!Array.isArray(details)) {
        this.coaDetails = [];
        this.updateFilteredCOAs();
        this.calculateTotal();
        return;
      }
      this.coaDetails = details.map(detail => this.mapExistingCOADetail(detail)).filter(Boolean);
      this.updateFilteredCOAs();
      this.calculateTotal();
    },
    populateApprovers(workflow) {
      if (!Array.isArray(workflow)) {
        this.approver = [];
        return;
      }
      const selected = [];
      workflow.forEach(wf => {
        if (!wf) return;
        const match = this.myBuMember.find(member => member.id === wf.id || member.user_id === wf.user_id || member.user_id === wf.id);
        if (match) {
          selected.push(match);
        } else {
          const fallback = {
            ...wf,
            id: wf.id || wf.user_id || (wf.user && wf.user.id) || null,
            user_id: wf.user_id || wf.id || (wf.user && wf.user.id) || null,
            business_unit: wf.business_unit || { bu_name: "" },
          };
          this.myBuMember.push(fallback);
          selected.push(fallback);
        }
      });
      this.approver = selected;
    },
    async loadExistingPV() {
      this.isLoading = true;
      try {
        const pvData = await this.fetchPVDetail(this.pvId);
        this.existingPV = pvData;
        this.currentImNo = pvData.imNo;
        this.selectedBU = `${pvData.imUser.id}-${pvData.imOrganization.id}`;
        this.subject = pvData.imPerihal || "";
        this.notes = pvData.notes || "";
        this.tembusan = Array.isArray(pvData.imCC) ? pvData.imCC : [];
        this.useAlias = pvData.imUseAlias !== undefined ? pvData.imUseAlias : this.useAlias;
        this.disabledHidetitle = pvData.imHideTitle || false;
        this.useLogo = pvData.imUseLogo !== undefined ? pvData.imUseLogo : this.useLogo;
        this.setUseAlias();
        this.fileName = Array.isArray(pvData.imFileLampiran) ? [...pvData.imFileLampiran] : [];
        this.file = [];
        this.totalDebit = parseFloat(pvData.totalDebit) || 0;
        this.totalCredit = parseFloat(pvData.totalCredit) || 0;
        this.grandTotal = parseFloat(pvData.grandTotal) || 0;
        await this.loadPaymentRequests();
        this.setExistingPaymentRequest(pvData.paymentRequest);
        await this.loadBankAccounts();
        this.setExistingBankAccount(pvData.bankAccount);
        await this.loadCOAList();
        this.setExistingCOADetails(pvData.coaDetails);
        await this.getMyBUMember();
        // Set bu_id after getMyBUMember
        const buId = this.selectedBU.split("-")[1] || this.selectedBU;
        this.bu_id = buId;
        await this.loadBUDetails();
        this.populateApprovers(pvData.imWorkflow);
      } catch (error) {
        console.error("Failed to load PV detail", error);
        this.$toasted.error("Failed to load PV detail", { icon: "error" });
      } finally {
        this.isInitializing = false;
        this.isLoading = false;
      }
    },
    async fetchCurrencyConfigs() {
      try {
        const response = await axios.get(`${process.env.VUE_APP_API_OLD}/api/currency`)
        this.currencyConfigs = response.data
        this.configsLoaded = true;
      } catch (error) {
        this.configsLoaded = true;
      }
    },
    async getMyActiveBU() {
      try {
        const token = localStorage.getItem("token");
        const userData = this.$store.state.dataUsers;
        const userId = userData.user || userData;
        if (userId) {
          const reqDataBU = await axios.get(
            `${process.env.VUE_APP_API}/users/active/bu/${userId._id}`,
            { headers: { Authorization: `Bearer ${token}` } }
          );
          const listBU = reqDataBU.data.data;
          // Filter by is_payment_voucher and is_active
          const filteredBU = listBU.filter(item => {
            return item.business_unit &&
                   item.business_unit.is_active === true &&
                   item.is_payment_voucher === true;
          });
          for (let i in filteredBU) {
            if (filteredBU.length == 1)
              filteredBU[i].label = `${filteredBU[i].business_unit.bu_name}`;
            else
              filteredBU[i].label = `${filteredBU[i].business_unit.bu_name} as ${
                filteredBU[i].position ? filteredBU[i].position : ""
              }`;
            filteredBU[i].value = `${filteredBU[i].id}-${filteredBU[i].business_unit.id}`;
          }
          this.myBuList = filteredBU;
        }
      } catch (e) {
        console.log(e);
      }
    },
    async onBUChange() {
      // Reset approver when BU changes
      this.approver = [];
      this.crosBu = [];
      this.searchCrossBU = null;
      this.isLoadingCrossBU = false;

      // Reset bank account related state so "Next" button stays disabled
      // until a new Bank Account is explicitly selected for the new BU.
      this.selectedBankAccount = null;
      this.selectedBankAccountData = null;
      this.accountName = "";
      this.accountNumber = "";
      this.bankAccounts = [];

      this.loadPaymentRequests();
      this.loadBankAccounts();

      // Reload BU members for the new BU
      await this.getMyBUMember();
      
      // Set bu_id for cross BU search and load BU details
      const buId = this.selectedBU.split("-")[1] || this.selectedBU;
      this.bu_id = buId;
      await this.loadBUDetails();
    },
    filterPaymentRequests(item, queryText) {
      const searchText = queryText.toLowerCase();
      const label = (item.label || '').toLowerCase();
      const imNo = (item.imNo || '').toLowerCase();
      return label.includes(searchText) || imNo.includes(searchText);
    },
    normalizePaymentRequests(raw) {
      const data = Array.isArray(raw)
        ? raw
        : (raw && Array.isArray(raw.data)) ? raw.data : [];
      const sorted = [...data].sort((a, b) => {
        const dateA = new Date(a.imDate || 0).getTime();
        const dateB = new Date(b.imDate || 0).getTime();
        return dateB - dateA;
      });
      return sorted.map(req => ({
        value: req._id,
        label: req.imPerihal,
        imNo: req.imNo,
        imPerihal: req.imPerihal,
        data: req
      }));
    },
    async loadPaymentRequests() {
      if (!this.selectedBU) return;
      const token = localStorage.getItem("token");
      const buId = this.selectedBU.split("-")[1] || this.selectedBU;
      const headers = { Authorization: `Bearer ${token}` };

      const loadFromNewApi = async () => {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/pv/available-for-pv`,
          { headers, params: { bu_id: buId } }
        );
        return response.data;
      };

      const loadFromLegacyApi = async () => {
        const response = await axios.get(
          `${process.env.VUE_APP_API_OLD}/api/pv/available-for-pv`,
          { headers, params: { bu_id: buId } }
        );
        return response.data;
      };

      try {
        const data = await loadFromNewApi();
        this.paymentRequests = this.normalizePaymentRequests(data);
        this.selectedPR = null;
        return;
      } catch (error) {
        console.warn("Failed to load payment requests from new API, trying legacy endpoint", error);
      }

      try {
        const legacyData = await loadFromLegacyApi();
        this.paymentRequests = this.normalizePaymentRequests(legacyData);
        this.selectedPR = null;
      } catch (legacyError) {
        console.error("Failed to load payment requests from both APIs", legacyError);
        this.paymentRequests = [];
      }
    },
    async loadBankAccounts() {
      if (!this.selectedBU) return;
      try {
        const token = localStorage.getItem("token");
        const buId = this.selectedBU.split("-")[1] || this.selectedBU;
        const response = await axios.get(
          `${process.env.VUE_APP_API}/pv/bank-accounts`,
          { 
            headers: { Authorization: `Bearer ${token}` },
            params: { bu: buId }
          }
        );
        this.bankAccounts = response.data.data
          .filter(acc => {
            // Handle backward compatibility: check both is_active and old status field
            if (acc.is_active !== undefined) {
              return acc.is_active === true;
            }
            // Fallback to old status field
            return acc.status === 'Active';
          })
          .map(acc => ({
            value: acc._id,
            label: `${(acc.bank && acc.bank.name) || acc.bank_name || '-' } - ${acc.account_name || '-' } - ${acc.account_no || '-'}`,
            data: acc
          }));
      } catch (error) {
        console.error("Failed to load bank accounts", error);
      }
    },
    onPRChange() {
      if (this.isInitializing) return;
      if (this.selectedPR && this.selectedPR.data) {
        this.subject = `Payment Voucher - ${this.selectedPR.data.imPerihal}`;
        this.prTotal = this.selectedPR.data.imPaymentData.paymentTotal;
        this.selectedCurrencyInput = this.selectedPR.data.imPaymentData.paymentCurrency.value || "IDR";
        this.selectedCurrency = { value: this.selectedCurrencyInput, text: this.selectedCurrencyInput };
        this.calculateTotal();
      }
    },
    onBankAccountChange() {
      if (this.selectedBankAccount && this.selectedBankAccount.data) {
        this.selectedBankAccountData = this.selectedBankAccount.data;
        this.accountName = this.selectedBankAccountData.account_name;
        this.accountNumber = this.selectedBankAccountData.account_no;
      }
    },
    async loadCOAList() {
      if (!this.selectedBU) return;
      try {
        const token = localStorage.getItem("token");
        const buId = this.selectedBU.split("-")[1] || this.selectedBU;
        const response = await axios.get(
          `${process.env.VUE_APP_API}/coa`,
          { 
            headers: { Authorization: `Bearer ${token}` },
            params: { bu: buId, limit: -1 }
          }
        );
        this.coaList = response.data.data
          .filter(coa => coa.status === true)
          .map(coa => ({
            value: coa._id,
            label: `${coa.code} - ${coa.description}`,
            kode: coa.code,
            accountType: coa.account_type || '',
            data: coa
          }));
        this.updateFilteredCOAs();
      } catch (error) {
        console.error("Failed to load COA", error);
      }
    },
    addCOADetail() {
      if (!this.addCOA) {
        this.$toasted.error("Please select a COA", { icon: "error" });
        return;
      }
      if (!this.addDescription || this.addDescription.trim() === '') {
        this.$toasted.error("Description is required", { icon: "error" });
        return;
      }
      if (!this.addAmount || this.addAmount <= 0) {
        this.$toasted.error("Please enter a valid amount", { icon: "error" });
        return;
      }
      
      const isDuplicate = this.coaDetails.some(detail => detail.coa.value === this.addCOA.value);
      if (isDuplicate) {
        this.$toasted.error("COA already added", { icon: "error" });
        return;
      }

      this.coaDetails.push({
        coa: this.addCOA,
        description: this.addDescription,
        type: this.addType,
        amount: parseFloat(this.addAmount)
      });
      
      this.updateFilteredCOAs();
      // Reset input fields
      this.addCOA = null;
      this.addDescription = "";
      this.addType = "debit";
      this.addAmount = 0;
      
      this.calculateTotal();
    },
    removeCOADetail(item) {
      const index = this.coaDetails.indexOf(item);
      if (index > -1) {
        this.coaDetails.splice(index, 1);
        this.updateFilteredCOAs();
        this.calculateTotal();
      }
    },
    updateFilteredCOAs() {
      const usedCOAIds = this.coaDetails.map(detail => detail.coa.value);
      this.filteredCOAs = this.coaList.filter(coa => !usedCOAIds.includes(coa.value));
    },
    filterCOA(item, queryText) {
      const searchText = queryText.toLowerCase();
      const label = (item.label || '').toLowerCase();
      const kode = (item.kode || '').toLowerCase();
      const accountType = (item.accountType || '').toLowerCase();
      return label.includes(searchText) || kode.includes(searchText) || accountType.includes(searchText);
    },
    calculateTotal() {
      this.totalDebit = this.coaDetails
        .filter(item => item.type === 'debit')
        .reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0);
      
      this.totalCredit = this.coaDetails
        .filter(item => item.type === 'credit')
        .reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0);
      
      this.grandTotal = Math.abs(this.totalDebit - this.totalCredit);
      
      // Validation
      if (Math.abs(this.totalDebit - this.totalCredit) > 0.01) {
        this.coaValidationAlert = true;
        this.coaValidationMessage = "Total Debit Accumulation must equal Total Credit Accumulation";
      } else if (Math.abs(this.totalDebit - this.prTotal) > 0.01) {
        this.coaValidationAlert = true;
        this.coaValidationMessage = `Total must equal Payment Request amount: ${this.formatCurrency(this.prTotal, this.selectedCurrency.value)}`;
      } else {
        this.coaValidationAlert = false;
        this.coaValidationMessage = "";
      }
    },
    formatCurrency(amount, currency) {
      if (!this.currencyConfigs[currency]) return amount;
      const config = this.currencyConfigs[currency];
      let formatted = parseFloat(amount).toFixed(config.precision || 2);
      if (config.decimal !== '.') {
        formatted = formatted.replace('.', config.decimal);
      }
      if (config.thousands) {
        const parts = formatted.split(config.decimal || '.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, config.thousands);
        formatted = parts.join(config.decimal || '.');
      }
      return formatted;
    },
    onCOAChange() {},
    onCurrencyChange() {
      this.selectedCurrency = { value: this.selectedCurrencyInput, text: this.selectedCurrencyInput };
    },
    async getMyBUMember() {
      try {
        const token = localStorage.getItem("token");
        const buId = this.selectedBU.split("-")[1] || this.selectedBU;
        const reqDataMyBUMember = await axios.get(
          `${process.env.VUE_APP_API}/users/bu/list/${buId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        // Ensure each member has user_id property
        this.myBuMember = reqDataMyBUMember.data.data.map(member => ({
          ...member,
          user_id: member.user_id || member.userId || null
        }));
        this.bu_id = buId;
      } catch (e) {
        console.log(e);
      }
    },
    async loadBUDetails() {
      if (!this.selectedBU || !this.bu_id) return;
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(
          `${process.env.VUE_APP_API}/business-unit/detail/${this.bu_id}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (this.use_setting_max_approver) {
          this.max_total_approver = response.data.max_approver ? response.data.max_approver : 0;
        }
      } catch (err) {
        console.error("Failed to load BU details", err);
      }
    },
    removeApp(item) {
      let result = [];
      for (const key in this.approver)
        if (this.approver[key].id != item.id) result.push(this.approver[key]);
      this.approver = result;
    },
    handleClearEvent(al) {
      let data1 = [];
      let data2 = [];
      let result = [];
      if (al == 1) {
        data1 = this.approver;
        data2 = this.myBuMember;
      } else if (al == 2) {
        data1 = this.approver;
        data2 = this.crosBu;
      }

      for (let i in data1) {
        let isFound = false;
        for (let j in data2) {
          if (data1[i].id == data2[j].id) isFound = true;
        }
        if (!isFound) result.push(data1[i]);
      }

      this.approver = result;
    },
    async submitPV(act) {
      this.isLoading = true;
      try {
        const token = localStorage.getItem("token");
        
        // Get selected BU details
        const selectedBUDetail = this.myBuList.find(bu => bu.value === this.selectedBU);
        if (!selectedBUDetail) {
          throw new Error("Invalid Business Unit selected");
        }

        // Get selected PR details
        if (!this.selectedPR || !this.selectedPR.data) {
          throw new Error("Payment Request not selected");
        }

        // Get selected Bank Account details
        if (!this.selectedBankAccount || !this.selectedBankAccount.data) {
          throw new Error("Bank Account not selected");
        }

        // Get approvers workflow
        const imWorkflow = this.approver.map((approver, index) => ({
          id: approver.id,
          user_id: approver.user_id,
          name: approver.name,
          alias: approver.alias,
          email: approver.email,
          msisdn: approver.msisdn !== undefined ? approver.msisdn : null,
          position: approver.position || '',
          business_unit: approver.business_unit || null,
          is_active: approver.is_active !== undefined ? approver.is_active : false,
          is_admin: approver.is_admin !== undefined ? approver.is_admin : false,
          isExternal: approver.isExternal !== undefined ? approver.isExternal : false,
          postAs: 'approver',
          comment: '',
          date: null,
          action: null,
        }));

        // Set status for first approver when submitting (same pattern as other imemo types)
        if (act === 2) {
          imWorkflow[0].status = 9;
        }

        // Prepare form data
        const formData = new FormData();
        formData.append("imType", "8");
        formData.append("imStatus", act.toString());
        const userData = this.$store.state.dataUsers;
        const currentUser = userData.user || userData;
        formData.append("userId", currentUser._id);
        const buIdParts = selectedBUDetail.value.split("-");
        // Backend (Express) expects `user` and `imApprover` fields, and `imOrganization` must include `bu_code`
        const prOrg = this.selectedPR.data.imOrganization || {};
        const buCode = prOrg.bu_code || (selectedBUDetail.business_unit && selectedBUDetail.business_unit.bu_code) || "";

        // Get full business unit details
        const buDetail = selectedBUDetail.business_unit || {};

        formData.append("user", JSON.stringify({
          id: buIdParts[0] || selectedBUDetail.value,
          alias: currentUser.alias,
          name: currentUser.full_name,
          email: currentUser.email,
          position: selectedBUDetail.position ? selectedBUDetail.position : '',
        }));

        // Include complete organization data with config fields needed for display
        formData.append("imOrganization", JSON.stringify({
          id: buIdParts[1] || selectedBUDetail.value,
          name: buDetail.bu_name || selectedBUDetail.label,
          bu_code: buCode,
          slug: buDetail.slug || "",
          logo: buDetail.logo || "",
          logo_align: buDetail.logo_align || "center",
          is_show_name: buDetail.is_show_name !== undefined ? buDetail.is_show_name : true,
          is_show_tagline: buDetail.is_show_tagline !== undefined ? buDetail.is_show_tagline : false,
          tagline: buDetail.tagline || "",
          is_active: buDetail.is_active !== undefined ? buDetail.is_active : true,
          settings: buDetail.settings || null,
        }));
        // Group used for numbering; use BU code to group counters per BU
        if (buCode) {
          formData.append("imGroup", buCode);
        }
        formData.append("imPerihal", this.subject);
        // Express expects YYYY-MM-DD
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        formData.append("imTargetDate", `${yyyy}-${mm}-${dd}`);
        formData.append("imUseAlias", this.useAlias.toString());
        formData.append("imHideTitle", this.disabledHidetitle.toString());
        formData.append("imUseLogo", this.useLogo.toString());
        formData.append("imApprover", JSON.stringify(imWorkflow));
        formData.append("imCC", JSON.stringify(this.tembusan || []));
        formData.append("paymentRequest", JSON.stringify({
          id: this.selectedPR.data._id,
          imNo: this.selectedPR.data.imNo,
          imPerihal: this.selectedPR.data.imPerihal,
          total: this.selectedPR.data.imPaymentData.paymentTotal,
          currency: this.selectedPR.data.imPaymentData.paymentCurrency.value,
        }));
        formData.append("bankAccount", JSON.stringify({
          id: this.selectedBankAccount.data._id,
          account_name: this.selectedBankAccount.data.account_name,
          account_no: this.selectedBankAccount.data.account_no,
          account_type: this.selectedBankAccount.data.account_type,
          currency: this.selectedBankAccount.data.currency,
          bank: this.selectedBankAccount.data.bank,
        }));
        formData.append("coaDetails", JSON.stringify(this.coaDetails.map(item => ({
          coa_id: item.coa.value,
          coa_code: item.coa.kode,
          coa_name: item.coa.data.description,
          description: item.description,
          type: item.type,
          amount: parseFloat(item.amount),
        }))));
        formData.append("totalDebit", this.totalDebit.toString());
        formData.append("totalCredit", this.totalCredit.toString());
        formData.append("currency", this.selectedCurrency.value);
        formData.append("notes", this.notes);

        const attachments = await this.prepareAttachmentPayload();
        formData.append(
          "imFileLampiran",
          attachments.length ? JSON.stringify(attachments) : null
        );
        formData.append("imFilelength", attachments.length.toString());

        if (this.existingPV && this.existingPV._id) {
          formData.append("_id", this.existingPV._id);
        }

        const targetUrl = this.isEditMode && this.currentImNo
          ? `${process.env.VUE_APP_API_OLD}/api/pv/imno/${this.currentImNo}`
          : `${process.env.VUE_APP_API_OLD}/api/pv`;
        const method = this.isEditMode && this.currentImNo ? "put" : "post";

        // Submit to backend (Express legacy API)
        const response = await axios({
          method,
          url: targetUrl,
          data: formData,
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        });

        if (response.status === 201 || response.status === 200) {
          const draftMsg = this.isEditMode ? "PV draft updated successfully" : "PV saved as draft successfully";
          const submitMsg = this.isEditMode ? "PV updated successfully" : "PV submitted successfully";
          this.$toasted.success(
            act === 1 ? draftMsg : submitMsg,
            { icon: "check_circle" }
          );
          this.$router.push("/my-request-pv");
        }
      } catch (e) {
        console.error(e);
        let errorMsg = "Failed to submit PV";
        if (e.response && e.response.data && e.response.data.message) {
          errorMsg = e.response.data.message;
        }
        this.$toasted.error(errorMsg, { icon: "error" });
      } finally {
        this.isLoading = false;
      }
    },
    async UploadAttachtment(file) {
      const formData = new FormData();
      formData.append("attachment", file);
      const config = {
        method: "post",
        url: process.env.VUE_APP_API + `/memo/upload-file`,
        headers: {
          Authorization: `Bearer ${this.$store.state.token}`,
          "Content-Type": "multipart/form-data",
        },
        data: formData,
      };
      try {
        const res = await axios(config);
        return res.data.data;
      } catch (err) {
        const err_msg =
          (err.response && err.response.data && err.response.data.message) ||
          err.message ||
          "Failed to upload attachment";
        this.$toasted.error(err_msg, { icon: "error" });
        throw err;
      }
    },
    getMoneyFormat(currency) {
      return this.currencyConfigs[currency] || this.currencyConfigs.USD;
    },
    async prepareAttachmentPayload() {
      const attachments = [];
      const pendingNames = new Set(
        this.file.map((pendingFile) => pendingFile && pendingFile.name).filter(Boolean)
      );

      if (Array.isArray(this.fileName) && this.fileName.length > 0) {
        for (const item of this.fileName) {
          if (!item) continue;
          const isObject = typeof item === "object";
          if (!isObject && pendingNames.has(item)) continue;
          attachments.push(item);
        }
      }

      if (this.file.length > 0) {
        for (const pendingFile of this.file) {
          const uploaded = await this.UploadAttachtment(pendingFile);
          if (uploaded) {
            attachments.push(uploaded);
          }
        }
        this.file = [];
      }

      this.fileName = attachments.slice();
      return attachments;
    },
    uploadLampiran() {
      // Similar to EditFormPayment.vue
      for (const key in this.$refs.file.files) {
        if (this.$refs.file.files[key].size != undefined) {
          if (this.$refs.file.files[key].size <= 5242880) {
            let check = this.file.filter(
              (data) => data.name == this.$refs.file.files[key].name
            );
            if (check.length == 0) {
              this.file.push(this.$refs.file.files[key]);
              this.fileName.push(this.$refs.file.files[key].name);
            }
            this.uploadAlert = false;
          } else {
            this.uploadAlert = true;
            document.getElementById("file").value = "";
          }
        }
      }
    },
    addFile() {
      for (const key in this.$refs.fileadd.files) {
        if (this.$refs.fileadd.files[key].size != undefined) {
          if (this.$refs.fileadd.files[key].size <= 5242880) {
            let check = this.file.filter(
              (data) => data.name == this.$refs.fileadd.files[key].name
            );
            if (check.length == 0) {
              this.file.push(this.$refs.fileadd.files[key]);
              this.fileName.push(this.$refs.fileadd.files[key].name);
            }
            this.uploadAlert = false;
          } else {
            this.uploadAlert = true;
            document.getElementById("file").value = "";
          }
        }
      }
    },
    removeLampiran(item, index) {
      const isUploadedAttachment = item && typeof item === "object";

      if (isUploadedAttachment) {
        this.fileName.splice(index, 1);
        return;
      }

      const targetName = typeof item === "string" ? item : item && item.name;
      if (targetName) {
        const fileIndex = this.file.findIndex(
          (pendingFile) => pendingFile && pendingFile.name === targetName
        );
        if (fileIndex > -1) {
          this.file.splice(fileIndex, 1);
        }
      }

      this.fileName.splice(index, 1);
    },
    setUseAlias() {
      if (this.useAlias) {
        this.disabledHidetitle = true;
      }
    },
  },
  watch: {
    useAlias(val) {
      if (val) {
        this.disabledHidetitle = true;
      }
    },
    approver() {
      if (this.approver.length <= 0) {
        this.alert = false;
      }
      if (this.approver.length > 0) {
        if (this.use_setting_max_approver && this.max_total_approver !== 0 && this.approver.length > this.max_total_approver) {
          this.alertMessage =
            `It reaches the maximum number (${this.max_total_approver}) of approver allowed in your BU!`;
          this.alert = true;
          this.approver.pop();
        }
      }
    },
    searchCrossBU: {
      handler(val) {
        if (val && val.length >= 3 && val.trim().length && this.bu_id) {
          this.isLoadingCrossBU = true;
          let token = localStorage.getItem("token");
          axios
            .get(
              process.env.VUE_APP_API +
                `/users/busines-unit/${this.bu_id}?key=${val}`,
              {
                headers: { Authorization: `Bearer ${token}` },
              }
            )
            .then(({ data }) => {
              const res = data.data;
              for (let i in res)
                if (
                  res[i].is_active &&
                  res[i].name != this.$store.state.dataUsers.user.full_name
                ) {
                  const alreadyAdded = this.approver.some(ap => ap.id === res[i].id);
                  const alreadyInList = this.crosBu.some(cb => cb.id === res[i].id);
                  if (!alreadyAdded && !alreadyInList) {
                    this.crosBu.push(res[i]);
                  }
                }
            })
            .catch((err) => {
              if (err.response && (err.response.status == 401 || err.response.status == 403)) {
                this.$store.dispatch("logout");
                return this.$router.push("/");
              }
            })
            .finally(() => (this.isLoadingCrossBU = false));
        }
      },
      immediate: false
    },
  },
  created() {
    this.initializePage();
  },
};
</script>

<style scoped>
.pv-stepper {
  background: white;
  margin-top: 0;
  box-shadow: none;
}

.badge-approval {
  background: #4caf501a;
  color: #4caf50;
  font-size: 12px;
  padding: 1rem;
  margin-top: 0.75rem;
}

.autocomplete-results {
  list-style: none;
  padding: 0;
}

.autocomplete-result {
  margin: 0.5rem 0;
}

.list-group {
  min-height: 20px;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.list-group-item {
  cursor: move;
}

.approver-number {
  font-weight: 500;
  font-size: 14px;
  min-width: 24px;
  margin-top: 0;
  margin-right: 4px;
  color: #333;
  display: flex;
  align-items: center;
}

.approver-list-item {
  align-items: center;
}

.approver-form-column {
  padding-left: 1rem;
  padding-right: 0.75rem;
}

.approval-tip-card {
  margin-top: 0.75rem;
}

::v-deep .v-data-table td {
  white-space: normal !important;
  vertical-align: top !important;
}

::v-deep .v-data-table td:nth-child(2) {
  max-width: 200px;
  word-wrap: break-word;
  white-space: normal !important;
  text-align: left !important;
  vertical-align: top !important;
}
</style>
